import React from 'react';
import {
  PieChart,
  TrendingUp,
  ShieldCheck,
  Activity,
  Target,
  Calculator,
  ArrowRight
} from 'lucide-react';
import { services, companyInfo } from '../data/mockData';

const iconMap = {
  pieChart: PieChart,
  trendingUp: TrendingUp,
  shield: ShieldCheck,
  activity: Activity,
  target: Target,
  calculator: Calculator
};

const ServiceCard = ({ service, onSelect }) => {
  const Icon = iconMap[service.icon] || PieChart;
  return (
    <div
      className="service-card"
      onClick={() => onSelect(service)}
      data-testid={`service-card-${service.id}`}
    >
      {service.isFree && (
        <span className="free-badge" data-testid="free-badge">FREE</span>
      )}

      <div className="service-icon">
        <Icon size={26} />
      </div>

      <h3 className="service-title">{service.title}</h3>
      <p className="service-description">{service.description}</p>

      <div className="service-cta">
        Learn More
        <ArrowRight size={16} className="service-arrow" />
      </div>
    </div>
  );
};

export const ServicesSection = () => {
  const goContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="section section-alt" data-testid="services-section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <h2 className="heading-1" data-testid="services-heading">Our Services</h2>
          <p
            className="body-large"
            style={{ maxWidth: '780px', margin: '0 auto', color: 'var(--text-secondary)' }}
          >
            Comprehensive financial solutions designed to secure your future and help you achieve
            your financial goals through expert guidance.
          </p>
        </div>

        <div className="services-grid services-grid--3" data-testid="services-grid">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} onSelect={goContact} />
          ))}
        </div>

        <div className="services-bottom-cta">
          <h3>Not sure where to begin?</h3>
          <p className="body-medium">
            Start with a complimentary financial diagnostic — a 30-minute call to map your goals,
            gaps and next best action.
          </p>
          <button
            onClick={() => window.open(companyInfo.googleCalendarLink, '_blank')}
            className="btn-primary pulse"
            data-testid="services-cta"
          >
            Schedule a Consultation
          </button>
        </div>
      </div>
    </section>
  );
};
